const STORAGE_KEY = "makers:employeeFilter";

export function stashMakersEmployeeFilter(ids: string[]): void {
  if (typeof window === "undefined" || ids.length === 0) return;
  window.sessionStorage.setItem(STORAGE_KEY, ids.join(","));
}

export function consumeMakersEmployeeFilter(): string[] | null {
  if (typeof window === "undefined") return null;
  const raw = window.sessionStorage.getItem(STORAGE_KEY);
  if (raw === null) return null;
  window.sessionStorage.removeItem(STORAGE_KEY);
  const ids = raw.split(",").filter(Boolean);
  return ids.length > 0 ? ids : null;
}
